import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TokenEncryptionService } from '../Services/token-encryption.service';
import { hasCompanyRole } from './role.utils';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenEncryptionService: TokenEncryptionService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user') || this.tokenEncryptionService.getEncryptedItem<any>('logedInUser');
    if (user && hasCompanyRole(user)) {
      return true;
    }

    // Redirect to dashboard if not company admin
    return this.router.createUrlTree(['/dashboard']);
  }
}
